import antdData from 'antd/lib/locale-provider/fr_FR'
import localeData from 'react-intl/locale-data/fr'

const messages = {
  'topBar.issuesHistory': 'Histoire des problèmes',
  'topBar.projectManagement': 'Gestion de projet',
  'topBar.typeToSearch': 'Chercher...',
  'topBar.buyNow': 'Acheter $26',
  'topBar.bitcoin': 'Bitcoin',
  'topBar.profileMenu.hello': 'Bonjour',
  'topBar.profileMenu.billingPlan': 'Plan de facturation',
  'topBar.profileMenu.role': 'Rôle',
  'topBar.profileMenu.email': 'Email',
  'topBar.profileMenu.phone': 'Téléphone',
  'topBar.profileMenu.editProfile': 'Editer le profil',
  'topBar.profileMenu.logout': 'Connectez - Out',

  /* ----------- Start Delete TracemarkID Popup ------------- */

  'deleteTracemarkID.link': 'Reset ownership to delete my Tracemark ID',
  'deleteTracemarkID.modal.header': 'Reset Tracemark ID',

  'deleteTracemarkID.step1.password': 'Insert your password',
  'deleteTracemarkID.step1.button': 'Validate',
  'deleteTracemarkID.step1.forgotPasswordLink': 'I forgot my password',

  'deleteTracemarkID.step2.resetText':
    'Please type the word RESET to confirm resetting your Tracemark ID and to allow for the ownership of this piece to be changed or for the piece to be returned.',

  'deleteTracemarkID.step3.success':
    'Thank you. The ownership and Tracemark ID for this piece have been reset.',

  /* ----------- End Delete TracemarkID Popup ------------- */

  /* ----------- Start Dynamic Panel Digital pass ------------- */
  'dynamicPanelsDigitalPass.header': 'Obtenez votre Passeport Tracemark',
  'dynamicPanelsDigitalPass.generateTracemarkIDButton': 'Obtenez votre Passeport Tracemark',

  'dynamicPanelsDigitalPass.uniqueCode':
    'Entrez le code alphanumérique affiché sur votre étiquette Tracemark',

  'dynamicPanelsDigitalPass.email': 'Email',
  'dynamicPanelsDigitalPass.email2': 'Email',
  'dynamicPanelsDigitalPass.firstName': 'Nom',
  'dynamicPanelsDigitalPass.lastName': 'Prénom',
  'dynamicPanelsDigitalPass.password': 'Mot de Passe',

  'dynamicPanelsDigitalPass.notificationHeader':
    'Votre identifiant Tracemark est en cours de téléchargement',
  'dynamicPanelsDigitalPass.notificationText':
    "Nous vous l'avons également envoyé en utilisant l'adresse e-mail fournie. Ouvrez l'identifiant Tracemark ci-joint sur votre smartphone pour l'enregistrer dans votre portefeuille numérique.",

  'dynamicPanelsDigitalPass.termsAndCondition1': "J'ai lu et j'accepte expressément la",
  'dynamicPanelsDigitalPass.termsAndCondition2': ' politique de confidentialité ',
  'dynamicPanelsDigitalPass.termsAndCondition3':
    'de "TRACEABLE LUXURY SERVICES, S.L." et les conditions de traitement de mes données personnelles.',

  'dynamicPanelsDigitalPass.resetOwnership':
    'Réinitialise la propriété de votre Passeport Tracemark',
  'dynamicPanelsDigitalPass.password.text':
    'Veuillez entrer votre mot de passe pour récupérer votre Passeport Tracemark',
  'dynamicPanelsDigitalPass.forgotPassword': 'Mot de passe oublié?',

  'dynamicPanelsDigitalPass.step1': 'Authentifiez votre pièce',
  'dynamicPanelsDigitalPass.step2': 'Générer un passeport Tracemark',
  'dynamicPanelsDigitalPass.Authenticate': 'Authentifier',
  'dynamicPanelsDigitalPass.personalDetails': 'Détails personnels',
  'dynamicPanelsDigitalPass.password.text1': 'Définir un mot de passe',
  'dynamicPanelsDigitalPass.password.text2':
    'Veuillez définir un mot de passe pour enregistrer votre propriété de ce bijou et sécuriser votre passeport Tracemark :',
  'dynamicPanelsDigitalPass.confirmPassword': 'Confirmez le mot de passe',

  'dynamicPanelsDigitalPass.required.uniqueCode': 'Veuillez entrer un code unique',
  'dynamicPanelsDigitalPass.required.name': 'Veuillez saisir votre prénom',
  'dynamicPanelsDigitalPass.required.lastName': 'Veuillez entrer votre nom de famille',
  'dynamicPanelsDigitalPass.required.email': 'Veuillez saisir votre adresse e-mail',
  'dynamicPanelsDigitalPass.required.validEmail': 'Veuillez entrer une adresse e-mail valide',
  'dynamicPanelsDigitalPass.required.terms': 'Veuillez accepter les termes et conditions',
  'dynamicPanelsDigitalPass.required.password': 'Veuillez entrer le mot de passe',
  'dynamicPanelsDigitalPass.required.confirmPassword': 'Veuillez saisir le mot de passe confirmé',
  'dynamicPanelsDigitalPass.required.matchPassword':
    'Votre nouveau mot de passe et votre mot de passe de confirmation ne correspondent pas',
  /* ----------- End  Dynamic Panel Digital pass ------------- */
}

export default {
  locale: 'fr-FR',
  antdData,
  localeData,
  messages,
}
